import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Box, Button } from "@mui/material";
import { styles } from "./styles";
import { featureList, openMailToLink } from "./helper";

export const EnterpriseDetails = () => {
  return (
    <>
      <p style={{ marginTop: "3px" }}>
        Contact us to learn more about our Enterprise offerings.
      </p>
      <Box sx={styles.contactUsContainer}>
        <Button
          onClick={openMailToLink}
          sx={{ ...styles.button, width: "100%", margin: 0 }}
        >
          Contact us
        </Button>
      </Box>
      <Box sx={styles.featureContainer}>
        <ul style={styles.featureUl}>
          {featureList.map((feature, index) => (
            <li key={index} style={styles.planDetailsRow}>
              <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
              {feature}
            </li>
          ))}
        </ul>
      </Box>
    </>
  );
};
